import { Outlet } from "react-router-dom";

const PrivateRoutes = () => {

  return <Outlet />

};

export default PrivateRoutes;

export const controlTowerMenuItems = [
  {
    id: 1,
    path: "/",
    label: "Dashboard",
  },
  {
    id: 2,
    path: "/ct-dashboard",
    label: "Dashboard",
  },
  {
    id: 3,
    path: "/core/supply/shipment",
    label: "Inbound Shipments",
    title: "Dashboard",
  },
  {
    id: 4,
    path: "core/supply/delivery",
    label: "Inbound Deliveries",
  },
  {
    id: 5,
    path: "/core/supply/order",
    label: "Purchase Orders",
  },
  {
    id: 6,
    path: "/core/demand/shipment",
    label: "Outbound Shipments",
  },
  {
    id: 7,
    path: "/core/demand/delivery",
    label: "Outbound Deliveries",
  },
  {
    id: 8,
    path: "/core/demand/order",
    label: "Sales Orders",
  },
  {
    id: 9,
    path: "/core/inventory/node/inventory",
    label: "Inventory",
  },
  {
    id: 10,
    path: "core/master-data/currency-conversion",
    label: "Currency Conversion",

  },
  {
    id: 11,
    path: "/fiscal-calendar",
    label: "Fiscal Calendar",
  },
  {
    id: 12,
    path: "/warehouse-capacity",
    label: "Warehouse Capacity",
  },
  {
    id: 13,
    path: "/core/analytics",
    label: "Analytics",
  },
  {
    id: 14,
    path: "/admin",
    label: "Admin",
  },
  {
    id: 15,
    path: "/documents",
    label: "Documents",
  },
  {
    id: 16,
    path: "/items",
    label: "Items",
  },
  {
    id: 17,
    path: "/sites",
    label: "Sites",
  },
  {
    id: 18,
    path: "/nodes",
    label: "Nodes",
  },
  {
    id: 19,
    path: "/sourcing-lanes",
    label: "Sourcing Lanes",
  },
  {
    id: 20,
    path: "/participants",
    label: "Participants",
  },
  {
    id: 21,
    path: "/batches",
    label: "Batches",
  },
  {
    id: 22,
    path: "/bods",
    label: "BODs",
  },
  {
    id: 23,
    path: "/boms",
    label: "BOMs",
  },
  {
    id: 24,
    path: "/traceability",
    label: "Traceability",
  },
  {
    id: 25,
    path: "/data-quality",
    label: "Data Quality",
  },
  {
    id: 25,
    path: "/core/user-roles/new-request",
    label: "New Request",
  },
  {
    id: 26,
    path: "/core/user-roles/track-access-request",
    label: "Request Status",
  },
  {
    id: 27,
    path: "/core/user-roles/reports",
    label: "Report",
  },
  {
    id: 28,
    path: "/core/user-roles/approval-rights",
    label: "Approval Delegation",
  },
];

export const appRootUrl = process.env.REACT_APP_ROOT_URL;
